import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    role: "user",
    documents: [],
    loadingMask: false,
    lang: "en",
    area_ID: "",
    qrcode_ID: "",
    page: ""
  },
  mutations: {
    set_page(state, str) {
      state.page = str;
    },
    setArea_ID(state, num) {
      state.area_ID = num;
    },
    setQrcode_ID(state, num) {
      state.qrcode_ID = num;
    },
    setLang(state, str) {
      state.lang = str;
    },
    setRole(state, str) {
      state.role = str;
    },
    setDocuments(state, documents) {
      state.documents = documents;
    },
    setLoadingMask(state, boolean) {
      state.loadingMask = boolean;
    }
  },
  actions: {
    fetchDocuments() {
      return axios.get("/api/document");
    }
  }
});
